import React from 'react'

const HomePage = () => {
  return (
    <div>blog home page</div>
  )
}

export default HomePage
